var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category_list_button"},[_c('div',{staticClass:"button"},[_c('icon',{staticClass:"list_button",attrs:{"size":"30"},on:{"click":_vm.showDialog}},[_vm._v("list")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }